import React from 'react';
import classNames from 'classnames';
import EmptyStateImg from 'assets/images/listing-empty-state.webp';
import { useTranslation } from 'react-i18next';
import { ListingType } from 'models/Listing';
import { ConditionalLink } from 'components/ConditionalLink';
import useGetListingRedirectUrl from 'hooks/useGetListingRecirectUrl';
import ResolveImage from 'components/ResolveImage';
import { DropzoneFile } from 'components/Dropzone/utils';

import './ListingInProtfolioEmptyState.styles.scss';

type ListingInProtfolioEmptyStateProps = {
  className?: string;
  dealRoomId: string;
  listingId: string;
  listingType: ListingType;
  listingIM: DropzoneFile;
  isDisabled?: boolean;
};

const ListingInProtfolioEmptyState: React.FC<
  ListingInProtfolioEmptyStateProps
> = (props) => {
  const {
    className,
    dealRoomId,
    listingType,
    listingId,
    listingIM,
    isDisabled,
  } = props;

  const classes = classNames('listing-in-protfolio-empty-state', className);

  const { t } = useTranslation();

  const listingUrl = useGetListingRedirectUrl()(
    dealRoomId,
    listingId,
    listingType,
    !!listingIM,
  );

  return (
    <div className={classes}>
      <ResolveImage
        src={EmptyStateImg}
        asIllustration
        alt="Listing not created yet."
      />
      <p>{t('marketADeal')}</p>

      <ConditionalLink isDisabled={isDisabled} to={listingUrl}>
        {t('draftListing')}
      </ConditionalLink>
    </div>
  );
};

export default ListingInProtfolioEmptyState;
